import { Bank } from "src/types/data";

const banks:Bank[] = [
        {
            "id": 2,
            "name": "ATTIJARIWAFA BANK",
            "photo": "attijari.png",
            "lien": "https://www.attijariwafabank.com/",
            "tele": "05.22.58.88.88",
            "email": "crc@attijariwafa.com",
            "facebook": '',
            "linkdin": "https://www.linkedin.com/company/attijariwafa-bank",
            "youtube": "https://www.youtube.com/user/AttijariwafabankCom",
            "instagram": '',
            "appstore": "https://apps.apple.com/us/app/attijari-mobile/id866031335?l=fr",
            "googleplay": "https://play.google.com/store/apps/details?id=com.attijariwafabank.main",
            "twitter": '',
            "slug": "attijariwafa-bank"
        },
        {
            "id": 7,
            "name": "CIH BANK",
            "photo": "cih.png",
            "lien": "http://www.cihbank.ma/",
            "tele": "0522479479",
            "email": "",
            "facebook": "https://www.facebook.com/pages/CIH-BANK/477913278976552",
            "linkdin": "",
            "youtube": "https://www.youtube.com/channel/UC2sZyU1dfxLlMIBGGvquJWg",
            "instagram": "https://www.instagram.com/cihbankma/",
            "appstore": "https://apps.apple.com/fr/app/cih-mobile/id664637221",
            "googleplay": "https://play.google.com/store/apps/details?id=com.b3g.cih.online&hl=fr&gl=FR",
            "twitter": "https://twitter.com/cihbank",
            "slug": "cih-bank"
        },
        {
            "id": 8,
            "name": "BANK OF AFRICA",
            "photo": "bankofafrica.jpeg",
            "lien": "https://www.bankofafrica.ma/",
            "tele": "0522999900",
            "email": "",
            "facebook": "https://www.facebook.com/BMCEBankOfAfrica",
            "linkdin": "https://www.linkedin.com/company/bank-of-africa-bmce-group",
            "youtube": "https://www.youtube.com/c/BMCEBankOfAfrica",
            "instagram": "https://www.instagram.com/bank_of_africa/",
            "appstore": "https://apps.apple.com/fr/app/bmce-direct/id515211306",
            "googleplay": "https://play.google.com/store/apps/details?id=com.BMCE_prod.bad&gl=MA&pli=1",
            "twitter": "https://twitter.com/Bank_OfAfrica",
            "slug": "bank-of-africa"
        },
        {
            "id": 9,
            "name": "BANQUE POPULAIRE",
            "photo": "Bp.jpeg",
            "lien": "https://bpnet.gbp.ma/home/Index",
            "tele": "2121",
            "email": "",
            "facebook": "https://www.facebook.com/PopulaireEtDigitale",
            "linkdin": "https://www.linkedin.com/company/bcp-bank",
            "youtube": "https://www.youtube.com/channel/UCOrSrjmPtk_z5ZByBSkubwA",
            "instagram": "",
            "appstore": "",
            "googleplay": "",
            "twitter": "https://twitter.com/BP_Maroc",
            "slug": "banque-populaire"
        },
        {
            "id": 10,
            "name": "AL BARID BANK",
            "photo": "baridbank.png",
            "lien": "https://www.albaridbank.ma/",
            "tele": "0802003232",
            "email": "",
            "facebook": "https://www.facebook.com/albaridbankofficiel",
            "linkdin": "https://www.linkedin.com/company/al-barid-bank",
            "youtube": "https://www.youtube.com/albaridbankofficiel",
            "instagram": "https://www.instagram.com/albaridbank.officiel",
            "appstore": "",
            "googleplay": "",
            "twitter": "",
            "slug": "al-barid-bank"
        },
        {
            "id": 11,
            "name": "CREDIT AGRICOLE",
            "photo": "creditagricole.png",
            "lien": "https://www.creditagricole.ma/",
            "tele": "",
            "email": "",
            "facebook": "",
            "linkdin": "",
            "youtube": "",
            "instagram": "",
            "appstore": "https://apps.apple.com/us/app/hssab-e/id1544070450",
            "googleplay": "https://play.google.com/store/apps/details?id=com.creditagricole.hssabe&hl=en_US&gl=MA",
            "twitter": "",
            "slug": "credit-agricole"
        },
        {
            "id": 15,
            "name": "SOCIETE GENERALE",
            "photo": "sg.png",
            "lien": "https://www.sgmaroc.com/",
            "tele": "4242",
            "email": "",
            "facebook": "https://www.facebook.com/societegenerale.maroc/",
            "linkdin": "https://fr.linkedin.com/company/societe-generale-maroc",
            "youtube": "https://www.youtube.com/channel/UC78NEQrhzaJKIkvcIRpTmUA",
            "instagram": "https://www.instagram.com/societegeneralemaroc/",
            "appstore": "https://apps.apple.com/fr/app/soci%C3%A9t%C3%A9-g%C3%A9n%C3%A9rale-maroc/id1055875915",
            "googleplay": "https://play.google.com/store/apps/details?id=com.sgma.prod&hl=fr",
            "twitter": "https://twitter.com/SG_Maroc",
            "slug": "societe-generale"
        },
        {
            "id": 23,
            "name": "CREDIT DU MAROC",
            "photo": "CDM.png",
            "lien": "https://www.creditdumaroc.ma/",
            "tele": "0522437437",
            "email": "",
            "facebook": "https://www.facebook.com/creditdumaroc/",
            "linkdin": "https://www.linkedin.com/company/credit-du-maroc/",
            "youtube": "https://www.youtube.com/@creditdumarocOfficiel",
            "instagram": "https://www.instagram.com/credit_du_maroc",
            "appstore": "https://itunes.apple.com/us/app/credit-du-maroc/id859052583?mt=8",
            "googleplay": "https://play.google.com/store/apps/details?id=com.mobiblanc.cdm",
            "twitter": "https://twitter.com/creditdumaroc",
            "slug": "credit-du-maroc"
        },
        {
            "id": 24,
            "name": "BMCI",
            "photo": "bmci.jpeg",
            "lien": "https://www.bmci.ma/",
            "tele": "2828",
            "email": "",
            "facebook": "https://www.facebook.com/bmcigroupebnpparibas/",
            "linkdin": "",
            "youtube": "https://www.youtube.com/user/BMCIgroupebnpparibas",
            "instagram": "",
            "appstore": "",
            "googleplay": "",
            "twitter": "https://twitter.com/BMCI_BNPP",
            "slug": "bmci"
        },
        {
            "id": 25,
            "name": "UMNIA BANK",
            "photo": "omnia.png",
            "lien": "https://www.umniabank.ma/",
            "tele": "0522645544",
            "email": "",
            "facebook": "https://www.facebook.com/UmniaBank/",
            "linkdin": "",
            "youtube": "https://www.youtube.com/channel/UCC0lX6F1uT4cCnTjouoGjmg",
            "instagram": "",
            "appstore": "https://apps.apple.com/fr/app/uconnect-by-umnia-bank/id1282330971",
            "googleplay": "https://play.google.com/store/apps/details?id=com.umnia.bank.retailmobile&hl=fr",
            "twitter": "",
            "slug": "umnia-bank"
        },
        {
            "id": 26,
            "name": "CFG BANK",
            "photo": "cfg.png",
            "lien": "https://www.cfgbank.com/particuliers/",
            "tele": "0522776800",
            "email": "",
            "facebook": "http://on.fb.me/1UtSFpi",
            "linkdin": "http://bit.ly/1LpVMg3",
            "youtube": "",
            "instagram": "",
            "appstore": "https://itunes.apple.com/fr/app/cfg-bank/id1160716282?mt=8",
            "googleplay": "https://play.google.com/store/apps/details?id=com.cfgbank.mobileapp&hl=fr",
            "twitter": "https://twitter.com/CFG_Bank",
            "slug": "cfg-bank"
        },
        {
            "id": 27,
            "name": "BANK AL YOUSR",
            "photo": "alyosr.jpeg",
            "lien": "https://www.alyousr.ma/fr",
            "tele": "0522585050",
            "email": "",
            "facebook": "https://www.facebook.com/AlYousrBank",
            "linkdin": "https://www.linkedin.com/company/bank-al-yousr-recrutement/?viewAsMember=true",
            "youtube": "https://www.youtube.com/channel/UCGyzUZ7GwmeNqH8P1IvjKeA",
            "instagram": "https://www.instagram.com/bank_al_yousr/?igshid=1wcj17hppua6q",
            "appstore": "",
            "googleplay": "https://play.google.com/store/apps/details?id=com.bayeer",
            "twitter": "",
            "slug": "bank-al-yousr"
        },
        {
            "id": 30,
            "name": "Bank assafa",
            "photo": "Saffa.jpeg",
            "lien": "https://www.bankassafa.com/fr",
            "tele": "0529040444",
            "email": "",
            "facebook": "https://www.facebook.com/BankAssafaOfficielle",
            "linkdin": "https://www.linkedin.com/company/bank-assafa",
            "youtube": "https://www.youtube.com/channel/UCluETr3Iek8SX1QPL-E7RZw",
            "instagram": "https://www.instagram.com/bank_assafa",
            "appstore": "https://apps.apple.com/fr/app/assafa-mobile/id1263972077",
            "googleplay": "https://play.google.com/store/apps/details?id=com.bankassafaa.main",
            "twitter": "",
            "slug": "bank-assafa"
        },
        {
            "id": 31,
            "name": "Wafacash",
            "photo": "logo_wafa.png",
            "lien": "https://www.wafacash.com/",
            "tele": "0522435050",
            "email": "",
            "facebook": "https://www.facebook.com/WafacashMaroc",
            "linkdin": "https://www.linkedin.com/company/wafacash",
            "youtube": "https://www.youtube.com/user/webwafacash",
            "instagram": "https://www.instagram.com/wafacash_maroc/",
            "appstore": "",
            "googleplay": "",
            "twitter": "https://twitter.com/wafacashmaroc?lang=fr",
            "slug": "wafacash"
        },
        {
            "id": 33,
            "name": "Cash Plus",
            "photo": "cashplus.jpeg",
            "lien": "https://www.cashplus.ma/",
            "tele": "0520020915",
            "email": "contact@cashplus.ma",
            "facebook": "https://facebook.com/Cashplusmaroc/",
            "linkdin": "https://www.linkedin.com/company/cash-plus/",
            "youtube": "https://www.youtube.com/c/CashPlusChannel",
            "instagram": "https://www.instagram.com/cashplusmaroc/",
            "appstore": "https://apps.apple.com/fr/app/cash-plus-mobile-wallet/id1479205181",
            "googleplay": "https://play.google.com/store/apps/details?id=com.cashplus.mobileapp&hl=fr&gl=US&pli=1",
            "twitter": "https://twitter.com/CashPlusMaroc",
            "slug": "cash-plus"
        }
    ];

/**
 * Get the bank object by bank ID.
 * @param {number} bankId - The ID of the bank.
 * @returns {Bank | ''} The bank object if found, otherwise ''.
 */
export function getBankById(bankId: number): Bank {
    const bank = banks.find(b => b.id === Number(bankId));
    if (!bank) {
      throw new Error(`Bank with ID ${bankId} not found.`);
    }
    return bank;
  }

  /**
   * Get the bank object by bank ID.
   * @param {number} bankId - The ID of the bank.
   * @returns {Bank | ''} The bank object if found, otherwise ''.
   */
  export function getBankNameById(bankId: number | string): string {
    const bank = banks.find(b => b.id === Number(bankId));
    if (!bank) {
      console.log(`Bank with ID ${bankId} not found.`);
      return 'N/A';
    }
    return bank.name;
  }
  
  export function getBanks(): Bank[] {
    return banks;
  }